import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personal-shopper',
  templateUrl: './personal-shopper.component.html',
  styleUrls: ['./personal-shopper.component.css']
})
export class PersonalShopperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
